import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CheckBoxSingle } from '../../../components/checkboxes/check-box-single';
import { Dropdown } from '../../../components/Dropdown/Dropdown';
import * as ProjectActionType from '../../constants';

const S1TimeZoneList = 'S1TimeZoneList';
const MONTH_LIST = [{text: 'Once a month', value: 0}];
const DAY_LIST = [{text: 'On the first day', value: 0}];
const HOUR_LIST = [{text: '0 AM',value: 0},{text: '1 AM',value: 1},{text: '2 AM',value: 2},{text: '3 AM',value: 3},{text: '4 AM',value: 4},{text: '5 AM',value: 5},{text: '6 AM',value: 6},{text: '7 AM',value: 7},{text: '8 AM',value: 8},{text: '9 AM',value: 9},{text: '10 AM',value: 10},{text: '11 AM',value: 11},{text: '12 AM',value: 12},{text: '1 PM',value: 13},{text: '2 PM',value: 14},{text: '3 PM',value: 15},{text: '4 PM',value: 16},{text: '5 PM',value: 17},{text: '6 PM',value: 18},{text: '7 PM',value: 19},{text: '8 PM',value: 20},{text: '9 PM',value: 21},{text: '10 PM',value: 22},{text: '11 PM',value: 23}];

export class Settings extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      projectId: PropTypes.string,
      scheduleSettings: PropTypes.object,
      timeZoneList: PropTypes.object
    }

    constructor(props) {
      super(props);

      this.state = {
        settingId: null,
        allowEmail: false,

        reminderDay: DAY_LIST[0],
        reminderMonth: MONTH_LIST[0],

        reminderTime: null,
        reminderTimezone: null,
        timeZoneList: []
      };

      if (!window.sessionStorage.getItem(S1TimeZoneList)) {
        this.getTimeZoneList(() => {
          this.setState({timeZoneList: this.props.timeZoneList}, this.getSettings);
          window.sessionStorage.setItem(S1TimeZoneList, JSON.stringify(this.props.timeZoneList));
        });
      }
      else {
        this.state.timeZoneList = JSON.parse(window.sessionStorage.getItem(S1TimeZoneList));
        this.getSettings();
      }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.scheduleSettings) {
        this.setState({
          settingId: nextProps.scheduleSettings.id,
          allowEmail: nextProps.scheduleSettings.reminderEmailChannel || false,
          reminderMonth: MONTH_LIST[nextProps.scheduleSettings.reminderFrequency || 0],
          reminderDay: DAY_LIST[nextProps.scheduleSettings.reminderFrequencySpecificDay || 0],
          reminderTime: HOUR_LIST[Number(nextProps.scheduleSettings.reminderTime.substr(0,2))],
          reminderTimezone: this.state.timeZoneList && this.state.timeZoneList.find(e => e.value === nextProps.scheduleSettings.reminderTimeZone)
        });
      }
    }

    onSelectedChange = (e, type) => {
      this.setState({ [type]: e.value }, this.saveChanged);
    }

    onChecked = (s, type) => {
      this.setState({ [type]: s.checked }, this.saveChanged);
    }

    getSettings = () => {
      this.props.dispatch({
        type: ProjectActionType.GET_MAINTENANCE_SETTINGS_ASYNC,
        params: {
          projectId: this.props.projectId
        }
      });
    }

    getTimeZoneList = (callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_MAINTENANCE_SETTINGS_TIMEZONE_ASYNC,
        callback: callback
      });
    }

    saveChanged = () => {
      this.props.dispatch({
        type: ProjectActionType.UPDATE_MAINTENANCE_SETTINGS_ASYNC,
        params: {
          projectId: this.props.projectId,
          reminderEmailChannel: this.state.allowEmail,
          reminderFrequencySpecificDay: this.state.reminderDay.value,
          reminderDayType: this.state.reminderMonth.value,
          reminderTime: `${this.state.reminderTime.value}:00:00`,
          reminderTimeZone: this.state.reminderTimezone.value
        }
      });
    }

    render() {
      const {reminderMonth, reminderDay, reminderTime, reminderTimezone, allowEmail, timeZoneList} = this.state;

      return (
        <React.Fragment>
          <div className='col-md-8' style={{padding: '15px 0'}} >
            <h5 style={{marginTop: 0}}>Sending options</h5>
            <h5>Channels</h5>
            <CheckBoxSingle
              label='Email'
              className='checkbox-default'
              checked={allowEmail}
              onChecked={(e, d, s) => this.onChecked(s, 'allowEmail')}
              style={{bottom: 10}}/>
            <h5>Reminder frequency</h5>
            <div style={{display: 'flex'}}>
              <Dropdown
                className='filestring-dropdown'
                options={MONTH_LIST}
                optionLabel='text'
                value={reminderMonth}
                style={{width: 200, marginRight: 10 }}
                onChange={(e) => this.onSelectedChange(e, 'reminderMonth')}
              />
              <Dropdown
                onChange={(e) => this.onSelectedChange(e, 'reminderDay')}
                className='filestring-dropdown'
                options={DAY_LIST}
                optionLabel='text'
                value={reminderDay}
                style={{ width: 200}}
              />
            </div>
            <div style={{display: 'flex'}}>
              <Dropdown
                onChange={(e) => this.onSelectedChange(e, 'reminderTime')}
                className='filestring-dropdown'
                options={HOUR_LIST}
                optionLabel='text'
                value={reminderTime}
                style={{width: 200, marginRight: 10}}
              />
              <Dropdown
                onChange={(e) => this.onSelectedChange(e, 'reminderTimezone')}
                className='filestring-dropdown'
                options={timeZoneList}
                optionLabel='name'
                value={reminderTimezone}
                style={{width: 450}}
              />
            </div>
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    timeZoneList: state.ProjectStore.TimeZoneList,
    scheduleSettings: state.ProjectStore.MaintenanceSchedule ? state.ProjectStore.MaintenanceSchedule.Settings : null
  };
};

export default withRouter(connect(mapStateToProps)(Settings));



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/settings.js